import React from "react";
import { TMenuCategory, TMenuItem } from "../types";
import { Box, Typography } from "@mui/material";
import MenuItem from "./MenuItem";
type ItemsByCategoryProps = {
    category: TMenuCategory
    orderItems: TMenuItem[]
    onShowClick: (item: TMenuItem) => void
    onAddClick: (item: TMenuItem) => void
    onRemoveClick: (item: TMenuItem) => void
    isOrderActive?: boolean
}
const ItemsByCategory: React.FC<ItemsByCategoryProps> = (props) => {
    const { category: { items, categoryName, _id }, onShowClick, onAddClick, onRemoveClick, orderItems, isOrderActive } = props;
    return <Box >
        <Box position={'relative'} bottom={'80px'} id={_id} />
        <Typography variant='h6' color='#666687'>{categoryName}</Typography>
        <Box pb='12px' />
        {items.map((item) => {
            const quantityInOrder = orderItems
                .filter(orderItem => item._id === orderItem._id)
                .reduce((acc, item) => acc + item.orderCount, 0)

            return <Box key={item._id}>
                <MenuItem
                    quantityInOrder={quantityInOrder}
                    item={item}
                    onShowClick={() => onShowClick(item)}
                    onAddClick={() => onAddClick(item)}
                    onRemoveClick={() => onRemoveClick(item)}
                    isOrderActive={isOrderActive}
                />
                <Box pb={'12px'} />
            </Box>
        })}
    </Box>
}

export default ItemsByCategory;